import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {

  successSnackbarTimeout = 5000;
  errorSnackbarTimeout = 10000;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  Error(message: string): Observable<never> {
    this.snackbar.error(message, { timeout: this.errorSnackbarTimeout });
    return EMPTY;
  }

  Success(message: string, options = { timeout: this.successSnackbarTimeout }): void {
    this.snackbar.success(message, options);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public get snackbar(): any {
    return this.document.querySelector('ds-snack-bar');
    // this.document.querySelector('ds-snack-bar') ||
    // (({ success: () => {} } as unknown) as HTMLDsSnackBarElement)
  }
}
